export const currency = [
    123.45,
    "123.45",
    "$123.45",
    123456.45,
    "123456.45",
    "123,456.45",
    "$123,456.45"];

export const decimal = [
    123.45,
    "123.45",
    "$123.45",
    123456.45,
    "123456.45",
    "123,456.45",
    "$123,456.45"];

export const decimal4 = [
    123.4567,
    "123.4567",
    "$123.4567",
    123456.4567,
    "123456.4567",
    "123,456.4567",
    "$123,456.4567"];


export const int = [
    123.45,
    123,
    -123,
    123456.45,
    "123456.45",
    "123",
    "123,456"];

export const percent = [
    123.45,
    123,
    -123,
    1.45,
    1,
    "1",
    "1%"];

export const dateTime = [
    new Date(),
    "23 Apr 2018",
    "2018-04-23",
    "2018-04-23T00:00:00",
    "2018-04-23T01:02:03"];



// WEBPACK FOOTER //
// ./src/areas/demo/primeroDemo/Coding/Items.js